import React, { ReactElement } from 'react';
import { Alert, List, Modal, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

type Props = {
  open: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const PAUSE_EFFECTS = [
  'Team will be marked as Paused — users will not be able to sign in.',
  'Team package will be set to expired.',
  'All users on the team will be set to expired.',
];

export const PauseSubscriptionModal = ({
  open,
  isLoading,
  onConfirm,
  onCancel,
}: Props): ReactElement => (
  <Modal
    title={
      <span>
        <ExclamationCircleOutlined className="text-yellow-500 mr-2" />
        Pause Subscription
      </span>
    }
    centered
    open={open}
    onOk={onConfirm}
    okText="Confirm Pause"
    okButtonProps={{ danger: true, loading: isLoading, disabled: isLoading }}
    cancelButtonProps={{ disabled: isLoading }}
    onCancel={onCancel}
    closable={false}
  >
    <Typography.Paragraph>
      You are about to <strong>pause</strong> this team&apos;s subscription. The
      following changes will take effect immediately:
    </Typography.Paragraph>
    <List
      dataSource={PAUSE_EFFECTS}
      renderItem={(item) => (
        <List.Item className="!px-0">
          <Typography.Text>{item}</Typography.Text>
        </List.Item>
      )}
    />
    <Alert
      type="warning"
      showIcon
      message="This action affects all users on the team. Please confirm you want to proceed."
      className="mt-2"
    />
  </Modal>
);

export default PauseSubscriptionModal;
